import React from 'react';

const VegIndicator = () => {
  return (
    <svg
      version='1.1'
      id='Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      width='20px'
      height='20px'
      viewBox='0 0 196 196'
      enableBackground='new 0 0 196 196'
      xmlSpace='preserve'
    >
      {' '}
      <image
        id='image0'
        width='196'
        height='196'
        x='0'
        y='0'
        xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMQAAADECAMAAAD3eH5ZAAAABGdBTUEAALGOfPtRkwAAACBjSFJN
    AACHDwAAjA8AAP1SAACBQAAAfXkAAOmLAAA85QAAGcxzPIV3AAAA1VBMVEX///8AmDAAmTMAmDIA
    mDIAmTMAmDMAmTMAkyYAlDIAlC8AmDEAljAAkDEAmDAAmTIAmTIAmTMAmTMAmDMAmTMAmTMAgAEA
    mDEAmTMAmTMAjywAmTIAmTIAkCoAmTMAmDIAmTMAAQEAlzIAmTMAlTAAmTIAmDIAmTIAmTMAmTMA
    iikAmTMAmTMAljMAljIAlzEAmTMAmTMAmTIAmDEAmDMAly8AmTMAmDEAmTMAiSMAmDMAmDMAmTMA
    ljEAmTIAmTMAly4AmTMAmTMAmDAAljEAmTP///9NUfaVAAAARXRSTlMAMXC2eLd2dwcaLTY8EEem
    y+tIj9H9AkWf8BJ53xnzjPYBZOomwcAlZvQNq9YkOktS+Uo7Zyf1ZekPipF6RqHTEaTJLDX3Bpjz
    AAAAAWJLR0QAiAUdSAAAAAlwSFlzAAAuIwAALiMBeKU/dgAAAAd0SU1FB+UBEggsLqbZoewAAAMc
    SURBVHja7dyJVtpAGIbhgFhABYUICqKCliJL3XCh7tt//7ek6bH1cOoRsszkm7/fewU+x4RJJjPj
    ZbLOl/Gy4nxZIkAiAqU/iIWcky1OIb55TpYnAiQiUCICJSJQIgIlIlAiAiUiUCICJSJQIgIlIlAi
    AiUiUCICJSJQIgIlIlAiAiUiUCICJSuIQnFpeWVlealYcBJRKudW1yryt8raaq5ccghRqPrrNfmk
    2rpfTfR/YgpR39hsyBc1Njfq4IjmVktm1tpqAiO2/Z3ZhKAdfxsUUdptz0cIau8mcZcnjejs7c9P
    CNrf66AhvnfDEYJ+9LAQB/3wBpH+ARBiMIxCCBoOUBC9UVSDyOgnBuKwEt3w9jxyiIA4CvHD+lnt
    o/QRxyfxDCInx2kjTmMb3hSn6SLGMa+l9ytqnCaiF+ue/qgScdhLAjGI8ds63SjaeJEEIvIY92/D
    tBBnyRlEztJBnF8kibg4TwPR6SZpEOlGeDKPjbhM1iByaR9RCvkONLvJL+uIq6QNIle2EcVEhurp
    2kXLiOvkDSLXdhHNSK+js+qHnY+Kh7gxYRC5sYmozzHPF6VWyBnOWIiyGYPIrUXEnSnEnT1EoRHn
    D/2qRriZ/ziIW1OGsNdTHIRvDuFbQ9ybQ9zbQjzUzCFqD5YQVXMGkaolRN4kIm8J8WgS8WgJ8WQS
    8WQJMTGJmNhBFEwaRMKM2dERRbOIMK930RHPZhHPVhAvZhEvVhBjs4gw0/z/OULF5aTixlbxE6ti
    sFPx2KHjAVDFo7iKlyIVr6cqJgpUTNnomDxTMY2pYkJZxdS+jo8sKj53qfjwqOMTsIqP8TqWRahY
    oKJjqZCKRVs6ls+pWMioY0mpjsW9OpZZq1jwrmPrgY5NIDq24+jYGKVji5qOzYI6tm16KjbQejq2
    MuvYVO6p2N4fpOCghSAFR14EKTh85HfuHwPznvMH8nzk+NFIdiICJSJQIgIlIlAiAiUiUCICJSJQ
    IgIlIlAiAiUiUCICJSJQIgIlIlAiAiUiUCICJSJQIgKlacRCzskWpxBORwRKRKCU9TJZ58u8Avt+
    csifF72dAAAAIXRFWHRDcmVhdGlvbiBUaW1lADIwMjE6MDE6MTUgMTk6MzM6MTQjFxM+AAAAJXRF
    WHRkYXRlOmNyZWF0ZQAyMDIxLTAxLTE4VDA4OjQ0OjQ2KzAzOjAwLv1C3QAAACV0RVh0ZGF0ZTpt
    b2RpZnkAMjAyMS0wMS0xOFQwODo0NDo0NiswMzowMF+g+mEAAAAASUVORK5CYII='
      />
    </svg>
  );
};

export default VegIndicator;
